import PropTypes from 'prop-types'

const BlogItem = ({ blog }) => {
  const decodeString = (strToDecode) => {
    const parser = new DOMParser()
    return parser.parseFromString(`<!doctype html><body>${strToDecode}`, 'text/html').body.textContent
  }

  const readMore = (text) => {
    if (text.length > 300) {
      return `${text.substr(0, 297)}...`
    }
    return text
  }

  return (
    <a href={blog?.url} className="blog-item shadow bg-white rounded blog-item h-100" target="_blank" rel="noreferrer">
      <img
        loading="lazy"
        width="360"
        height="360"
        src={blog?.image}
        alt={decodeString(blog?.title || '')}
        className="blog-img"
      />
      <span className="blog-info">
        <span className="blog-title d-block">{decodeString(blog?.title || '')}</span>
        <span className="blog-description d-block">
          <span>{readMore(decodeString(blog?.excerpt || blog?.description || ''))}</span>
        </span>
      </span>
    </a>
  )
}

BlogItem.propTypes = {
  blog: PropTypes.instanceOf(Object).isRequired
}

export default BlogItem
